export const OPPORTUNITY_CREATE_MODAL_NAME = 'OpportunityCreateForm';
